<div class="container">
  <img src="../../../assets/images/not-data.svg" />
  <h1 *ngIf="title">{{ title }}</h1>
  <h2 *ngIf="subtitle">{{ subtitle }}</h2>
</div>
